import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http'

@Injectable()
export class RecruitmentService {

  constructor(private http:HttpClient) { }

  getMenu(){
  	return this.http.get("http://api.thegbu.in/recruitmentcontent/");
  }

  getContent(page){
  	return this.http.get("http://api.thegbu.in/recruitmentcontent/"+page, {responseType: 'text'});
		
  }
}



// WEBPACK FOOTER //
// ./src/app/services/recruitment.service.ts